import React, { useCallback, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { ChevronRight, ChevronDown, Search, Info, FileQuestion } from "lucide-react";
import storage from "../../../../Storage";
import C from "../../../../Constant";
import coins from "../../../coins";
import socket from "../../../../Socket";
import { Col, Dropdown } from "react-bootstrap";
import {
  __, wait, decode, encode, forceSatoshiFormat, Event,
  isMobile,
  sendNotfication,
  getUID,
} from '../../../../Helper';
import { walletService } from '../../../../utils/Services';

/* ------------------ small missing helpers ------------------ */
const networkCoinMap = {
  ETH: 'eth',
  TRX: 'trx',
  BSC: 'bsc',
  // extend if you need
};
const coinsList = Array.isArray(coins) ? coins : []; // safe fallback

/* ------------------ styled components (kept same) ------------------ */
// ... (all styled components from your file) ...
// For brevity here I'll reuse the styled-components you had earlier —
// paste the same styled-components definitions you already use above exactly as they were.
// (In this code-block I kept them unchanged from your original to avoid duplication issues.)

const WithdrawContainer = styled.div`
  margin: 0 auto;
  padding: 24px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;
const Row1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
`;
const Label1 = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  
  ${props => props.isGreen && `
    color: #20EE89;
    font-size: 16px;
    font-weight: 500;
  `}
  
  ${props => props.isGray && `
    color: #9ba1a6;
    font-size: 14px;
  `}
`;
const Amount = styled.div`
${props => props.isGreen && `
    color: #20EE89;
  `}
  font-size: ${props => props.large ? '16px' : '14px'};
  font-weight: ${props => props.bold ? '600' : '400'};
`;
const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  &:hover {
    opacity: 1;
  }
`;
const Container = styled.div`
  padding: 8px;
  color: #ffffff;
`;
const DropdownContainer = styled.div`
  position: relative;
  margin-bottom: 16px;
  flex:1;
`;
const DropdownButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding:6px 10px;
     background: rgb(30, 35, 40);
  border: 1px solid rgba(255, 255, 255, 0.05);
 
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
`;
const DropdownPanel = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
     background: rgb(30, 35, 40);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border: 1px solid rgb(58 65 66);
  border-radius: 8px;
  margin-top: 4px;
  max-height: 400px;
  overflow-y: auto;
  z-index: 900;
  padding:10px 12px;
`;
const SearchContainer = styled.div`
  position: relative;
  padding:0px;
    border-radius: 8px;
  border: 1px solid rgb(58 65 66);
  margin-top:12px;
`;
const SearchInput = styled.input`
  width: 100%;
  padding: 6px 12px 6px 40px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 16px;
  &::placeholder {
    color: #fff;
    opacity:0.6;
  }
`;
const Input = styled.input`
width:100%;
  padding:6px 10px;
     background: rgb(30, 35, 40);
  border: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom:12px;
  // border: 1px solid rgb(58 65 66);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  &::placeholder {
    color: #fff;
    opacity:0.4;
  }
`;
const DepositButton = styled.div`
  margin-top: auto;
flex:1;
padding:7px 9px;
  display:flex;
  justify-content:center;
  align-items:center;
 background:#FF5C5C;
  color: black !important;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  
  &:hover {
    opacity: 0.9;
  }
`;
const SearchIcon = styled.div`
  position: absolute;
  left: 14px;
  top: 49%;
  transform: translateY(-50%);
  color: #fff;
`;
const CoinOption = styled.div`
  display: flex;
  align-items: center;
  padding: 14px;
  cursor: pointer;
  border-radius:12px;
  &:hover {
    background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.1);
  }
  ${props => props.isSelected && `
       background: rgba(0, 0, 0, 0.25);
    border-color: rgba(255, 255, 255, 0.1)  
  `}
`;
const CoinImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 12px;
`;
const CoinName = styled.div`
  font-size: 16px;
  font-weight: bold;
`;
const CoinBalance = styled.span`
  margin-left: auto;
  color: #8E9293;
   display:none;
`;
const TokenListContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
`;
const TokenButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #394142;
  border-radius: 100px;
  border: none;
  cursor: pointer;
  color: #ffffff;
  transition: background 0.2s ease;
  &:hover {
    background: #363A3B;
  }
`;
const TokenIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;
const TokenName = styled.div`
  font-size: 14px;
  font-weight: 500;
`;
const MoreButton = styled(TokenButton)`
  padding: 8px 12px;
`;
const FooterText = styled.div`
  color: #ffffff;
  margin: 18px 0;
`;
const AddLink = styled.span`
  color: #20EE89;
  cursor: pointer;
`;
const QRCodeContainer = styled.div`
  width: 120px;
  height: 120px;
  background-color: #fff;
  border-radius: 4px;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Label = styled.div`
  color: #9ba1a6;
  font-size: 14px;
`;
const AddressContainer = styled.div`
  background-color: #2c3235;
  padding: 12px 16px;
  border-radius: 6px;
  color: #fff;
  font-family: monospace;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
const CopyButton = styled.button`
  background-color: #3c4246;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  transition: background-color 0.2s;
  white-space: nowrap;
  
  &:hover {
    background-color: #4c5256;
  }
`;
const CopyIcon = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: currentColor;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z' /%3E%3C/svg%3E");
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;
`;
const CodeContainer = styled.div`
  border-radius: 8px;
  display: flex;
  gap: 20px;
  align-items: center;
  margin: 12px auto;
`;
const WarningContainer = styled.div`
  background-color: rgba(52, 199, 89, 0.1);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px auto;
  margin-bottom: 16px;
`;
const IconWrapper = styled.div`
  width: 20px;
  height: 20px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const WarningText = styled.span`
  color: #fff;
  font-size: 13px;
  font-weight: 500;
`;
const WarningTextGreen = styled.span`
color: #34C759;
font-size: 14px;
font-weight: 500;
`;
const BonusContainer = styled.div`
  background-color: rgba(180, 155, 100, 0.2);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px auto;
  margin-bottom: 16px;
`;
const IconWrapper1 = styled.div`
  width: 28px;
  height: 28px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
`;
const BaseText = styled.span`
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
`;
const HighlightedText = styled(BaseText)`
  color: #FF5C5C;
`;

/* ------------------ component ------------------ */

const SkylaMobileWithdraw = () => {
  // UI states
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [chainName, setChainName] = useState("");
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const address = "0x5e6E82fc1117AE06c8b1230164284Ec5d0141Df";
  const [copied, setCopied] = useState(false);

  // Coin and amount related
  const [credits, setCredits] = useState({});
  const [selectedCoin, setSelectedCoin] = useState(storage.getKey('coin') || "INR");
  const [state, setState] = useState({
    currentCoin: storage.getKey('coin') || "MVR",
    credits: {},
    list: [],
    content: [],
    wallet: "btc",
    deposit: true,
    slide: false,
    height: 573,
    margin: "mt-1",
    amount: "",
    coinId: "",
    networks: [],
    selectedNetwork: "",
    qrString: "",
    coinName: "",
    logoUrl: "",
    isLoading: false,
    isCopied: false,
    depositAddress: "",
    depositAmount: "",
    showDepositDetails: false
  });

  // Withdraw fields
  const [withdrawAddress, setWithdrawAddress] = useState("");
  const [withdrawAddressError, setWithdrawAddressError] = useState("");
  const [error3, setError3] = useState("");
  const [final, setFinal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [placeholder, setPlaceholder] = useState("");
  const [showTwoFactorInput, setShowTwoFactorInput] = useState(false);
  const [twoFactorCode, setTwoFactorCode] = useState('');
  const [is2FAEnabled, setIs2FAEnabled] = useState(false);
  const [inrWithdrawalType, setInrWithdrawalType] = useState("bank");
  const [bankName, setBankName] = useState("");
  const [upiId, setUpiId] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");

  // Wager/eligibility states
  const [eligible, setEligible] = useState(true);
  const [wagerInfo, setWagerInfo] = useState(null);
  const [checkingEligibility, setCheckingEligibility] = useState(false);
  const [showWagerModal, setShowWagerModal] = useState(false);
  const [progressPercent, setProgressPercent] = useState(0);

  // Refs
  const initialCoinRef = useRef(storage.getKey('coin') || "INR");
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => { mountedRef.current = false; };
  }, []);

  /* ------------------ helpers ------------------ */
  const isFiatCurrency = () => {
    const fiatCurrencies = ['INR', 'MVR', 'PKR', 'NPR', 'AED', 'SC', 'BDT'];
    return fiatCurrencies.includes(selectedCoin);
  };

  const getCoinNameByNetwork = useCallback((network, coinInfo, defaultCoin) => {
    if (networkCoinMap[network]) return networkCoinMap[network];
    if (coinInfo && coinInfo.id) return coinInfo.id;
    return defaultCoin.toLowerCase();
  }, []);

  /* ------------------ load coin details ------------------ */
  const loadCoinId = useCallback(async (coin) => {
    if (!coin) return;
    if (['INR','MVR','PKR','AED'].includes(coin.toUpperCase())) {
      // fiat skip
      return;
    }
    setState(prev => ({ ...prev, isLoading: true }));
    try {
      const response = await walletService.getCoinDetails({ symbol: coin.toUpperCase() }); // adapt if your api differs
      const { coinId, networks, coinFullName, logoUrl } = response || {};
      let networksList = networks ? Object.keys(networks) : [];
      const coinInfo = coinsList.find(item => item.symbol === coin.toUpperCase());
      let selectedNet = networksList[0] || "";
      if (coin.toUpperCase() === 'USDT') {
        networksList = ['ETH','TRX','BSC'];
      }
      const coinName = getCoinNameByNetwork(selectedNet, coinInfo, coin);
      setState(prev => ({ ...prev, coinId, networks: networksList, selectedNetwork: selectedNet, coinName, logoUrl, isLoading: false }));
      setSelectedNetwork(selectedNet);
    } catch (err) {
      console.error("Error in loadCoinId:", err);
      setState(prev => ({ ...prev, isLoading: false }));
    }
  }, [getCoinNameByNetwork]);

  /* ------------------ socket credit handlers (named) ------------------ */
  const handleCreditData = useCallback((data) => {
    try {
      const decodedData = decode(data);
      const { credit } = decodedData;
      setCredits(credit);
      const currentCoin = __.lowerCase(selectedCoin);
      const currentCredit = forceSatoshiFormat(credit[currentCoin]);
      storage.setKey('credit', currentCredit);
    } catch (err) {
      console.error('handleCreditData decode error', err);
    }
  }, [selectedCoin]);

  const handleCreditUpdate = useCallback((data) => {
    try {
      const decodedData = decode(data);
      const { value, coin: updatedCoin } = decodedData;
      const formattedValue = forceSatoshiFormat(value);
      setCredits(prev => ({ ...prev, [__.lowerCase(updatedCoin)]: value }));
      if (__.lowerCase(updatedCoin) === __.lowerCase(selectedCoin)) {
        storage.setKey('credit', formattedValue);
      }
    } catch (err) {
      console.error('handleCreditUpdate decode error', err);
    }
  }, [selectedCoin]);

  /* ------------------ initial/mount effects ------------------ */
  useEffect(() => {
    const token = storage.getKey('token');
    if (token) {
      socket.emit(C.CREDIT, encode({ coin: initialCoinRef.current }));
    }
    socket.on(C.CREDIT, handleCreditData);
    socket.on(C.UPDATE_CREDIT, handleCreditUpdate);

    Event.on && Event.on("deposit_archive", () => {
      setState(prev => ({ ...prev, slide: !prev.slide }));
    });

    wait(400).then(() => loadCoinId(initialCoinRef.current));

    return () => {
      socket.off(C.CREDIT, handleCreditData);
      socket.off(C.UPDATE_CREDIT, handleCreditUpdate);
      Event.off && Event.off("deposit_archive");
    };
  }, [handleCreditData, handleCreditUpdate, loadCoinId]);

  useEffect(() => {
    if (selectedCoin === "MVR") {
      setPlaceholder("Enter Withdraw Amount (Minmim 500MVR and Maximum 50,000MVR)");
    } else {
      setPlaceholder("Enter Withdraw Amount");
    }
  }, [selectedCoin]);

  /* ------------------ eligibility check ------------------ */
  const checkWagerEligibility = useCallback(async () => {
     const token = storage.getKey('token');
     const uid = getUID();
     if (!token || !uid) {
       // default to disabled if missing auth
       setEligible(false);
       return;
     }
     setCheckingEligibility(true);
     try {
       const url = `https://api.ibitplay.com/check-wager/${uid}`;
       const res = await axios.get(url, {
         headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
       });
       const data = res.data || {};
       setWagerInfo(data);
       setEligible(Boolean(data.eligible));
     } catch (err) {
       console.error("Failed to check wager eligibility:", err);
       // On error, safe default: disable withdrawals
       setEligible(false);
     } finally {
       setCheckingEligibility(false);
     }
   }, []);

   useEffect(() => {

      checkWagerEligibility();
    }, [checkWagerEligibility]);  
 

  /* ------------------ onWithdrawButtonClick (main gating) ------------------ */
  const onWithdrawButtonClick = async (e) => {
    e?.preventDefault?.();
    if (checkingEligibility || loading) {
      sendNotfication("Please wait...", "info", "top-right");
      return;
    }

    // Ensure latest eligibility when clicked
    await checkWagerEligibility();

    if (eligible) {
      // proceed to normal submit flow (this will validate fields etc)
      handleSubmit();
    } else {
      // open modal showing wager progress
      setShowWagerModal(true);

      // compute percent safely
      const current = Number(wagerInfo?.wager || 0);
      const required = Number(wagerInfo?.required || 0);
      const targetPct = required > 0 ? Math.max(0, Math.min(100, Math.round((current / required) * 100))) : 0;

      // animate progressPercent from 0 to targetPct
      setProgressPercent(0);
      const start = performance.now();
      const duration = 700;
      const animate = (ts) => {
        const t = Math.min(1, (ts - start) / duration);
        const ease = 1 - Math.pow(1 - t, 3); // easeOutCubic
        const value = Math.round(ease * targetPct);
        if (mountedRef.current) setProgressPercent(value);
        if (t < 1 && mountedRef.current) requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    }
  };

  const closeWagerModal = () => setShowWagerModal(false);

  const onModalDepositCTA = () => {
    setShowWagerModal(false);
    if (Event && Event.emit) Event.emit('open_deposit');
  };

  /* ------------------ submit handlers (unchanged logic mostly) ------------------ */
  const processFiatWithdrawal = async () => {
    if (!state.amount || parseFloat(state.amount) <= 0) {
      sendNotfication("Please enter a valid amount", "error", "top-right");
      return;
    }
    if (!accountHolderName) {
      sendNotfication("Account holder name is required", "error", "top-right");
      return;
    }
    if (selectedCoin !== 'INR' && selectedCoin !== 'BDT' && (!bankName || !accountNumber)) {
      sendNotfication("Bank details are required for withdrawals", "error", "top-right");
      return;
    }
    setState(prev => ({ ...prev, isLoading: true }));
    const payload = {
      uid: getUID().toString(),
      amount: state.amount,
      currency: selectedCoin,
      withdrawal_type: 'bank',
      bank_name: bankName,
      account_number: accountNumber,
      account_holder_name: accountHolderName,
      upi_id: upiId
    };
    try {
      const response = await walletService.createFiatWithdrawal(payload);
      if (response) {
        sendNotfication("Withdrawal request submitted successfully", "success", "top-right");
        setState(prev => ({ ...prev, amount: "" }));
        setBankName(""); setAccountNumber(""); setAccountHolderName(""); setUpiId("");
        setTimeout(() => window.location.reload(), 2000);
      } else {
        sendNotfication("Failed to submit withdrawal request", "error", "top-right");
      }
    } catch (err) {
      console.error("Error processing fiat withdrawal:", err);
      sendNotfication(err?.response?.data?.error || "Error processing withdrawal", "error", "top-right");
    } finally {
      if (mountedRef.current) setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const submitFormCrypto = (e) => {
    if (e) e.preventDefault();
    if (!withdrawAddress.trim()) {
      setWithdrawAddressError('Withdraw address is required');
      return;
    } else {
      setWithdrawAddressError('');
    }
    if (!chainName.trim()) {
      sendNotfication("Chain required", "error", "top-right");
      return;
    }
    if (!state.amount || parseFloat(state.amount) <= 0) {
      setError3("Please enter a valid amount");
      return;
    }
    const fee = 0.01 * parseFloat(state.amount);
    const finalAmount = parseFloat(state.amount) - fee;
    if (finalAmount <= 0) {
      setError3("Amount after fee must be greater than 0");
      return;
    }
    const coin_info = coins.find(item => item.preffix.toLowerCase() === selectedCoin.toLowerCase());
    if (coin_info && finalAmount < Number(coin_info.min)) {
      setError3(`Minimum withdrawal amount is ${coin_info.min} ${selectedCoin}`);
      return;
    }
    if (!final) { setFinal(true); return; }

    setLoading(true);
    setTimeout(() => {
      socket.emit(
        C.SUBMIT_NEW_WITHDRAWL,
        encode({
          coin: selectedCoin,
          wallet: withdrawAddress,
          amount: state.amount,
          immed: fee,
          password: password,
          chain: chainName,
          network: selectedNetwork
        })
      );

      setState(prev => ({ ...prev, amount: "" }));
      setWithdrawAddress("");
      setPassword("");
      setPasswordError("");
      setFinal(false);
      setLoading(false);

      sendNotfication("Withdrawal request submitted successfully", "success", "top-right");
      setTimeout(() => window.location.reload(), 2000);
    }, 500);
  };

  const handleConfirmWithdraw = () => {
    if (!password.trim()) {
      setPasswordError("Password is required");
      return;
    }
    submitFormCrypto();
  };

  // 2FA verification
  const handleTwoFactorVerification = async () => {
    if (!twoFactorCode.trim()) {
      sendNotfication('Please enter verification code', 'error', 'top-right');
      return;
    }
    try {
      const response = await walletService.verify2FA({ uid: getUID(), token: twoFactorCode });
      if (response.success) {
        setShowTwoFactorInput(false);
        setTwoFactorCode('');
        if (isFiatCurrency()) processFiatWithdrawal();
        else submitFormCrypto();
      } else {
        sendNotfication('Invalid verification code', 'error', 'top-right');
      }
    } catch (err) {
      sendNotfication('Failed to verify code', 'error', 'top-right');
    }
  };

  // Primary submit flow (this will be called when eligible)
  const handleSubmit = async () => {
    if (error3) return;

    // Optionally check 2FA status before proceeding (uncomment if desired)
    // const twoFA = await walletService.get2FAStatus(getUID());
    // if (twoFA?.isEnabled) { setShowTwoFactorInput(true); return; }

    if (isFiatCurrency()) processFiatWithdrawal();
    else submitFormCrypto();
  };

  /* ------------------ helper UI functions etc ------------------ */
  const handleCopy = () => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCoinSelect = async (coinName) => {
    if (storage.getKey('coin') === coinName) {
      setIsOpen(false);
      return;
    }
    storage.setKey('coin', coinName);
    const credit = forceSatoshiFormat(credits[__.lowerCase(coinName)] || 0);
    storage.setKey('credit', credit);
    setSelectedCoin(coinName);
    setIsOpen(false);
    try {
      await wait(200);
      Event.emit('coin_changed', coinName);
    } catch (err) {
      console.error(err);
    }
  };

  const filteredCoins = coins
    .filter(coin => {
      if (coin.preffix === 'BJT' || coin.preffix === 'SC') return false;
      return coin.preffix.toLowerCase().includes(searchTerm.toLowerCase());
    })
    .sort((a, b) => {
      if (a.preffix === 'BTC') return -1;
      if (b.preffix === 'BTC') return 1;
      return 0;
    });

  const selectedCoinData = coins.find(coin => coin.preffix === selectedCoin);

  /* ------------------ UI render ------------------ */

  return (
    <Container>
      <div style={{ display: "flex", gap: "5px", width: "100%" }}>
        <div style={{ flex: '1' }}>
          <div style={{ color: "#B3BEC1", margin: "4px 0" }}>Deposit Currency</div>
          <DropdownContainer>
            <DropdownButton onClick={(e) => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <CoinImage
                  src={`/assets/images/${selectedCoinData?.image}`}
                  alt={selectedCoin}
                />
                <CoinName>{selectedCoin}</CoinName>
              </div>
              <ChevronDown size={20} />
            </DropdownButton>

            {isOpen && (
              <DropdownPanel onClick={e => e.stopPropagation()}>
                <SearchContainer>
                  <SearchIcon>
                    <Search size={20} />
                  </SearchIcon>
                  <SearchInput
                    placeholder="Search coins..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    autoFocus
                  />
                </SearchContainer>

                {filteredCoins.map((coin) => (
                  <CoinOption
                    key={coin.id || coin.preffix}
                    onClick={() => handleCoinSelect(coin.preffix)}
                    isSelected={selectedCoin === coin.preffix}
                  >
                    <CoinImage src={`/assets/images/${coin.image}`} alt={coin.preffix} />
                    <CoinName>{coin.preffix}</CoinName>
                    <CoinBalance>
                      {forceSatoshiFormat(credits[__.lowerCase(coin.preffix)] || 0)}
                    </CoinBalance>
                  </CoinOption>
                ))}
              </DropdownPanel>
            )}
          </DropdownContainer>
        </div>
      </div>

      <div style={{ flex: "1", width: "100%" }}>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ color: "#B3BEC1", margin: "4px 0" }}>
            Withdrawl Amount
          </div>
        </div>
      </div>

      <div style={{ width: "100%" }}>
        <Input
          value={state.amount}
          onChange={(e) => {
            const newAmount = e.target.value;
            setState((prev) => ({ ...prev, amount: newAmount }));
            setError3("");
            if (selectedCoin === "MVR") {
              const amount = parseFloat(newAmount);
              if (newAmount && !isNaN(amount)) {
                if (amount < 500) setError3("Minimum withdrawal amount for MVR is 500");
                else if (amount > 50000) setError3("Maximum withdrawal amount for MVR is 50,000");
              }
            }
          }}
          placeholder={placeholder}
        />
        {error3 && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "4px", marginBottom: "8px" }}>
            {error3}
          </div>
        )}
      </div>

      {isFiatCurrency() && (
        <>
          {/* bank/upi fields */}
          <div style={{ marginTop: "20px" }}>
            <div style={{ color: "#B3BEC1", margin: "4px 0" }}>Select Withdrawal Method</div>
            <div style={{ display: "flex", gap: "10px" }}>
              
              <button
                onClick={() => setInrWithdrawalType("bank")}
                style={{
                  backgroundColor: inrWithdrawalType === "bank" ? "#f09c06" : "#2B3139",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "4px",
                  color: "white",
                  cursor: "pointer"
                }}
              >
                Bank Transfer
              </button>
            </div>

            <div style={{ color: "#B3BEC1", margin: "4px 0", marginTop: 12 }}>Account Holder Name</div>
            <Input value={accountHolderName} onChange={(e) => setAccountHolderName(e.target.value)} placeholder="Enter Account Holder Name" />

            {inrWithdrawalType === "upi" ? (
              <>
                <div style={{ color: "#B3BEC1", margin: "10px 0 4px 0" }}>UPI ID</div>
                <Input value={upiId} onChange={(e) => setUpiId(e.target.value)} placeholder="Enter UPI ID (example@upi)" />
              </>
            ) : (
              <>
                <div style={{ color: "#B3BEC1", margin: "10px 0 4px 0" }}>Bank Name</div>
                <Input value={bankName} onChange={(e) => setBankName(e.target.value)} placeholder="Enter Bank Name" />
                <div style={{ color: "#B3BEC1", margin: "10px 0 4px 0" }}>Account Number</div>
                <Input value={accountNumber} onChange={(e) => setAccountNumber(e.target.value)} placeholder="Enter Account Number" />
              </>
            )}
          </div>
        </>
      )}

      <WithdrawContainer>
        <Row1>
          <Label1 isGreen>Withdraw amount</Label1>
          <Amount isGreen large bold>
            {parseFloat(state.amount || 0).toFixed(isFiatCurrency() ? 2 : 8)} {selectedCoin}
          </Amount>
        </Row1>

        {!isFiatCurrency() && (
          <Row1>
            <Label1 isGray>
              Fee (1%):
              <IconButton><FileQuestion /></IconButton>
            </Label1>
            <Amount>{(parseFloat(state.amount || 0) * 0.01).toFixed(8)} {selectedCoin}</Amount>
          </Row1>
        )}

        <Row1>
          <Label1 isGray>Total Withdraw amount</Label1>
          <Amount>
            {isFiatCurrency() ? (parseFloat(state.amount || 0)).toFixed(2) : (parseFloat(state.amount || 0) * 0.99).toFixed(8)} {selectedCoin}
          </Amount>
        </Row1>
      </WithdrawContainer>

      {/* Eligibility notice */}
      {!eligible && (
        <div style={{ color: '#FFCC00', margin: '8px 0', fontSize: 13 }}>
          Withdrawals are disabled for your account. {wagerInfo?.wager !== undefined && `Wager: ${wagerInfo.wager}.`} Please complete wagering/deposit requirements or contact support.
        </div>
      )}

      <DepositButton
        onClick={onWithdrawButtonClick}
        role="button"
        aria-disabled={checkingEligibility || loading}
        style={{
          opacity: (checkingEligibility || loading) ? 0.6 : 1,
          cursor: (checkingEligibility || loading) ? 'not-allowed' : 'pointer'
        }}
      >
        {checkingEligibility ? "Checking..." : (loading ? "Processing..." : (isFiatCurrency() ? "Withdraw" : (final ? "Confirm Withdrawal" : "Preview")))}
      </DepositButton>

      {/* Confirmation Modal for Crypto Withdrawals */}
      {final && !isFiatCurrency() && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex',
          justifyContent: 'center', alignItems: 'center', zIndex: 1000
        }}>
          <div style={{
            backgroundColor: '#1E2329', padding: '24px', borderRadius: '8px',
            maxWidth: '500px', width: '90%'
          }}>
            <h3 style={{ color: 'white', marginBottom: '16px' }}>Confirm Withdrawal</h3>

            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#B3BEC1' }}>Address:</span>
                <span style={{ color: 'white', wordBreak: 'break-all' }}>{withdrawAddress}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#B3BEC1' }}>Network:</span>
                <span style={{ color: 'white' }}>{selectedCoin}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#B3BEC1' }}>Chain:</span>
                <span style={{ color: 'white' }}>{chainName}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#B3BEC1' }}>Amount:</span>
                <span style={{ color: 'white' }}>{parseFloat(state.amount).toFixed(8)} {selectedCoin}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#B3BEC1' }}>Fee (1%):</span>
                <span style={{ color: 'white' }}>{(parseFloat(state.amount) * 0.01).toFixed(8)} {selectedCoin}</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                <span style={{ color: '#B3BEC1' }}>You will receive:</span>
                <span style={{ color: '#0ECB81' }}>{(parseFloat(state.amount) * 0.99).toFixed(8)} {selectedCoin}</span>
              </div>

              <div style={{ marginTop: '16px' }}>
                <span style={{ color: '#B3BEC1', display: 'block', marginBottom: '8px' }}>
                  Enter your password to confirm withdrawal
                </span>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  style={{
                    width: '100%',
                    backgroundColor: '#2B3139',
                    border: '1px solid #424B52',
                    padding: '10px 12px',
                    borderRadius: '4px',
                    color: 'white'
                  }}
                />
                {passwordError && (
                  <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                    {passwordError}
                  </div>
                )}
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button onClick={() => setFinal(false)} style={{ backgroundColor: 'transparent', border: '1px solid #B3BEC1', color: '#B3BEC1', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
              <button onClick={handleConfirmWithdraw} style={{ backgroundColor: '#0ECB81', border: 'none', color: 'white', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}>Confirm</button>
            </div>
          </div>
        </div>
      )}

      {/* Wager requirement modal */}
      {showWagerModal && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2200
        }} onClick={closeWagerModal}>
          <div style={{ background: '#1E2329', padding: 20, borderRadius: 12, width: 480, maxWidth: '95%' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3 style={{ margin: 0, color: '#fff' }}>Wager Requirement Incomplete</h3>
              <button onClick={closeWagerModal} style={{ background: 'transparent', border: 'none', color: '#ccc', fontSize: 20, cursor: 'pointer' }}>×</button>
            </div>

            <p style={{ color: '#B3BEC1', marginTop: 8 }}>
              Your current wager is lower than the required amount for withdrawals. Increase your wagering or deposit to unlock withdrawals.
            </p>

            <div style={{ display: 'flex', gap: 12, marginTop: 14 }}>
              <div style={{ flex: 1 }}>
                <div style={{ color: '#999', fontSize: 13 }}>Current wager</div>
                <div style={{ marginTop: 6, fontWeight: 600, fontSize: 16 }}>{(wagerInfo?.wager ?? 0).toLocaleString()}</div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ color: '#999', fontSize: 13 }}>Required wager</div>
                <div style={{ marginTop: 6, fontWeight: 600, fontSize: 16 }}>{(wagerInfo?.required ?? 0).toLocaleString()}</div>
              </div>
            </div>

            <div style={{ marginTop: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <div style={{ color: '#B3BEC1', fontSize: 13 }}>Progress to required wager</div>
                <div style={{ color: '#fff', fontWeight: 600, fontSize: 13 }}>{progressPercent}%</div>
              </div>
              <div style={{ height: 12, borderRadius: 999, background: '#2b2f32', overflow: 'hidden' }}>
                <div style={{
                  height: '100%',
                  width: `${progressPercent}%`,
                  transition: 'width 300ms cubic-bezier(.22,.9,.34,1)',
                  background: 'linear-gradient(90deg, #FFD54F, #FFB300)'
                }} />
              </div>
            </div>

            <div style={{ marginTop: 18, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button onClick={closeWagerModal} style={{ background: 'transparent', border: '1px solid #3b3f42', color: '#B3BEC1', padding: 8, borderRadius: 8, cursor: 'pointer' }}>Close</button>
              {/* <button onClick={onModalDepositCTA} style={{ background: '#FFCC00', border: 'none', padding: 8, borderRadius: 8, cursor: 'pointer', fontWeight: 700 }}>Deposit to meet requirement</button> */}
            </div>
          </div>
        </div>
      )}

      {showTwoFactorInput && (
        <div style={{
          position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
        }}>
          <div style={{ backgroundColor: '#1E2329', padding: 24, borderRadius: 8, maxWidth: 500, width: '90%' }}>
            <h3 style={{ color: 'white', marginBottom: 16 }}>Two-Factor Authentication</h3>
            <div style={{ marginBottom: 16 }}>
              <span style={{ color: '#B3BEC1', display: 'block', marginBottom: 8 }}>Enter your 2FA verification code</span>
              <input type="text" value={twoFactorCode} onChange={(e) => setTwoFactorCode(e.target.value)} placeholder="Enter verification code" style={{ width: '100%', backgroundColor: '#2B3139', border: '1px solid #424B52', padding: '10px 12px', borderRadius: 4, color: 'white' }} />
            </div>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowTwoFactorInput(false)} style={{ backgroundColor: 'transparent', border: '1px solid #B3BEC1', color: '#B3BEC1', padding: '8px 16px', borderRadius: 4, cursor: 'pointer' }}>Cancel</button>
              <button onClick={handleTwoFactorVerification} style={{ backgroundColor: '#0ECB81', border: 'none', color: 'white', padding: '8px 16px', borderRadius: 4, cursor: 'pointer' }}>Verify</button>
            </div>
          </div>
        </div>
      )}

      {selectedCoin === "MVR" && (
        <WarningTextGreen>Note:Total 2 withdrawals per day,Unlimited withdrawal players can swap MVR to Crypto</WarningTextGreen>
      )}

      <WarningContainer>
        <WarningText>
          {isFiatCurrency()
            ? "For security purposes, large or suspicious withdrawal may take 1-6 hours for audit process. We appreciate your patience!"
            : `Please ensure you're using the correct ${selectedNetwork || state.selectedNetwork} network for your ${selectedCoin} withdrawal. Sending to an incorrect network may result in permanent loss of funds.`
          }
        </WarningText>
      </WarningContainer>
    </Container>
  );
};

export default SkylaMobileWithdraw;
